module.exports = __webpack_public_path__ + "build/img/connexions_1000.87015e52.png";